"use client";
import { trackRequestQuoteModal } from "@/lib/Utility";
import { useSearchParams } from "next/navigation";
import { useEffect } from "react";

interface Props {
  onQuoteParam: () => void;
}

export function SearchParamsHandler({ onQuoteParam }: Props) {
  const searchParams = useSearchParams();
  useEffect(() => {
    if (searchParams.has("request-a-quote")) {
      trackRequestQuoteModal();
      onQuoteParam();
    }
  }, [searchParams, onQuoteParam]);
  return null;
}
